<template>
  <div class="index">
    
    <topNav></topNav>
    
    <div class="top" :style="{'background-image':'url('+aboutUsNav[curAbout].bg+')','position':'relative','width':'100%','height':'600px','background-size':'auto 100%','background-position':'0px 0px'}" >  
    </div>

             <!--<img src="static/china_real_estate_industry_green_supply_chain_action.png" style="position:absolute;left:25px;top:150px;width:50%;" />-->
    <div style="position:absolute;left:25px;top:150px;width:68%;text-align:left;" class="brief_1 Impact" >Green Supply Chain Action in China’s Real Estate Industry</div>

    <!--<img src="static/under_top_logo.png" style="position:absolute;left:25px;top:200px;width:150px;" />-->

    <div style="position:absolute;left:25px;top:260px;width:55%;text-align:left;" class="brief_1 Impact"  v-if="$store.state.language === 'cn'">中国房地产行业<br/>绿色供应链行动</div>



     


    <pageLocation :currentLocation="curPage"></pageLocation>



    <div class="aboutUs" v-if="curAbout==0" style="width:100%;height:auto;margin:120px auto 0px auto;" >
      <!-- aboutUs start -->
      <div style="border-bottom:1px solid #57802b;width:80%;margin:0 auto;padding-bottom:30px;">
     <div style="width:80%;margin:0 auto"><div style="width:150px;display:block;margin:0 auto; color:#57802b" class="brief_1 Impact">Contact Us</div></div>
     <div style="width:80%;margin:0 auto"><img src='static/msc.png' style="width:200px;display:block;margin:10px auto auto auto;"></div>
     </div>
     
     <div style="width:80%;margin:20px auto">

       <img src="static/address_and_phone.png" style="width:100%;margin:0 auto;" />
         
         <img src="static/add_map.png" style="width:100%;margin:0 auto;"  />
 
        <img src="static/wx.png" style="margin:0 auto;"  />
 
     </div>
 
 
 <!--aboutUs end-->
    </div>

 
 
    <!--底部组件-->
    <friendLinkAndFooter></friendLinkAndFooter>

 
 
  </div>
</template>


<script>
import { articleListByPage,articleDetail } from "@/api";
import Swiper from 'swiper'
import 'swiper/dist/css/swiper.min.css'
import friendLinkAndFooter from '@/components/friendLinkAndFooter'
import topNav from '@/components/topNav'
import pageLocation from '@/components/pageLocation'
export default {
  name: 'contactUs',
  components:{
   topNav,friendLinkAndFooter,pageLocation
  },
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      showNav:false,
      pages:1,
      //联系我们
      curPage:'联系我们',
      curAbout:0,
      curArticleCode:'000000246',
      curArticleContent:{},
      
      aboutUsNav:[
        {'name':'联系我们','articleCode':'000000246','catCode':'','bg':'static/contact_us_top_bg.png'}
      ]
    }
  },
  methods :{
 
  
  },
   mounted() {
     var that=this;

 
 
 

    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>



.brief_1{
    font-size: 20px;
    font-weight: 900;
    color: #fff;
}
.Impact {
    font-family: Impact,微软雅黑;
}

.about_us_nav{margin:0px;padding:0px;display:flex;position:absolute;bottom:-20px;width:90%;left:5%;box-shadow:#ebebeb 5px 5px 5px 5px;}
.about_us_nav li{margin:0px;padding:0px;width:50%;text-align:center;height:35px;line-height: 35px;font-size: 12px;}

.show{display:block;}
.item{width:100%;height:50px;margin:0px;display:block;}
.itemActive{background:#89a128;color:#fff;}
.itemNoActive{background:#fff;color:#89a128;}
.hidden{display:none;}
.index{
  margin:0px;
  padding:0px;
  width: 100%;
  min-height: 960px;
}

.top{position:relative;width:100%;height:600px;background-size:auto 100%;background-position:0px 0px}


.navBox{width:150px;}
.navBox li{height:30px;}
.navBox li a{color:#fff;text-align:right;display:block;width:100%;text-decoration: none;}




.declarationItem{width:45%;float:left;overflow:hidden;margin:10px 2% 10px 2%;padding:0px;height:260px;}
.declarationItem li{margin:0px;padding:0px;}

 


 
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/contactUs.vue